import React from 'react';
import { Icon, Tooltip } from 'antd';
import {
  ContractCard,
  ContractIcon,
  ContractTitle,
  ContractDivider,
  ContractDate,
  ContractActions,
  CreateCard,
  ContractTitleWrapper
} from './styles';
import { formatContractDate } from '../../utils/contractHelpers';
import { BUSINESS_CONTRACTS as trans } from './translationValues';

const ContractCardComponent = ({ contract, onEdit, onDelete, onCreate, isCreateCard = false, t }) => {
  if (isCreateCard) {
    return (
      <CreateCard onClick={onCreate} isCreateCard={true}>
        <Icon type="plus" className="create-icon" />
        <div className="create-title">
          {t(trans.CREATE_NEW_CONTRACT.key, trans.CREATE_NEW_CONTRACT.value)}
        </div>
        <div className="create-subtitle">
          {t(trans.ADD_NEW_CONTRACT.key, trans.ADD_NEW_CONTRACT.value)}
        </div>
      </CreateCard>
    );
  }

  const handleCardClick = (e) => {
    // Don't trigger card click if clicking on action buttons
    if (e.target.closest('.contract-actions')) {
      return;
    }
    onEdit(contract.id);
  };

  const handleActionClick = (e, action) => {
    e.stopPropagation();
    if (action === 'edit') {
      onEdit(contract.id);
    } else if (action === 'delete') {
      onDelete(contract.id);
    }
  };

  return (
    <ContractCard onClick={handleCardClick}>
      <ContractActions className="contract-actions">
        <Icon type="edit" onClick={(e) => handleActionClick(e, 'edit')} />
        <Icon type="delete" onClick={(e) => handleActionClick(e, 'delete')} />
      </ContractActions>
      <ContractIcon>
        <span style={{ fontSize: '20px', fontWeight: 'bold' }}>{'{'}</span>
        <span style={{ fontSize: '20px', fontWeight: 'bold' }}>{'}'}</span>
      </ContractIcon>
      <ContractTitleWrapper>
        <Tooltip title={contract.name} placement="top">
          <ContractTitle>{contract.name}</ContractTitle>
        </Tooltip>
      </ContractTitleWrapper>
      <ContractDivider />
      <ContractDate>
        {t(trans.MODIFIED.key, trans.MODIFIED.value)} {formatContractDate(contract.updatedAt)}
      </ContractDate>
    </ContractCard>
  );
};

export default ContractCardComponent;

